<template>
  <div class="doge-shell">
    <header class="doge-top">
      <button class="doge-back" @click="$router.back()">‹</button>
      <h1 class="doge-title">{{ title }}</h1>
      <div class="doge-placeholder"></div>
    </header>
    <main class="doge-page-pad">
      <section v-if="showProfitSummary" class="profit-summary">
        <div><span>{{ isEn ? 'Yesterday Earnings' : '昨日收益' }}</span><b>{{ summaryMoney(yesterdayProfit) }}USDT</b></div>
        <div><span>{{ isEn ? 'Total Earnings' : '累计收益' }}</span><b>{{ summaryMoney(totalProfit) }}USDT</b></div>
      </section>
      <div class="record-tabs">
        <button :class="{active: tab === 'all'}" @click="tab='all'">{{ isEn ? 'All' : '全部' }}</button>
        <button :class="{active: tab === 'in'}" @click="tab='in'">{{ isEn ? 'Income' : '收入' }}</button>
        <button :class="{active: tab === 'out'}" @click="tab='out'">{{ isEn ? 'Investment/Expense' : '投资/支出' }}</button>
      </div>
      <div v-for="item in filteredList" :key="item.source + '-' + item.id" class="detail-card">
        <div class="doge-row">
          <span>{{ formatTime(item.created_at) }}</span>
          <b :class="statusClass(item)">{{ displayStatus(item) }}</b>
        </div>
        <div class="doge-divider"></div>
        <div class="doge-row">
          <span>{{ displayTypeLabel(item) }}</span>
          <b :class="item.kind === 'in' ? 'doge-status-green' : ''">{{ item.kind === 'in' ? '+' : '-' }}{{ money(item.amount) }}USDT</b>
        </div>
        <div v-if="item.tx_hash" class="hash-row">Hash: {{ formatHash(item.tx_hash) }}</div>
        <div v-if="item.address" class="hash-row">{{ isEn ? 'Address' : '地址' }}：{{ formatHash(item.address) }}</div>
      </div>
      <div v-if="!filteredList.length" class="doge-empty">{{ isEn ? 'No records' : '暂无记录' }}</div>
      <button v-if="hasMore" class="load-more" :disabled="loadingMore" @click="loadMore">
        {{ loadingMore ? (isEn ? 'Loading...' : '加载中...') : (isEn ? 'Load More' : '加载更多') }}
      </button>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
export default {
  name: 'billList',
  components: { BottomNav },
  data() { return { list: [], profitSummary: null, tab: 'all', page: 1, pageSize: 20, hasMore: false, loadingMore: false }; },
  computed: {
    isEn() { return this.$i18n && this.$i18n.locale === 'en'; },
    title() {
      if (this.$route.query.type === '2') return this.isEn ? 'Withdrawal Records' : '提现记录';
      if (this.$route.query.type === '1') return this.isEn ? 'Deposit Records' : '充值记录';
      return this.isEn ? 'Fund Details' : '资金明细';
    },
    showProfitSummary() { return !this.$route.query.type; },
    totalProfit() { return this.profitSummary ? this.profitSummary.total_profit : null; },
    yesterdayProfit() { return this.profitSummary ? this.profitSummary.yesterday_profit : null; },
    filteredList() { if (this.tab === 'all') return this.list; return this.list.filter(item => item.kind === this.tab); }
  },
  watch: { '$route.query.type': 'resetLoad' },
  mounted() { this.load(); },
  methods: {
    resetLoad() { this.page = 1; this.list = []; this.profitSummary = null; this.hasMore = false; this.load(); },
    async loadMore() { if (!this.hasMore || this.loadingMore) return; this.page += 1; await this.load(true); },
    async load(append = false) {
      this.loadingMore = append;
      try {
        await this.$store.dispatch('ensureDogeAuth');
        const type = this.$route.query.type;
        const params = { page: this.page, limit: this.pageSize };
        let r;
        if (type === '2') {
          r = await this.$axios.get('/api/doge/withdraws', { params });
        } else if (type === '1') {
          r = await this.$axios.get('/api/doge/deposits', { params });
        } else {
          r = await this.$axios.get('/api/doge/account_logs', { params });
        }
        if (!type) {
          const summary = r && r.data && r.data.data && r.data.data.profit_summary;
          this.profitSummary = summary || null;
        }
        const arr = this.rows(r);
        let mapped;
        if (type === '2') mapped = arr.map(x => ({ id: x.id, source: 'withdraw', created_at: x.created_at, amount: x.usdt_amount, kind: 'out', status: Number(x.status), statusText: this.withdrawStatus(x.status), tx_hash: x.tx_hash, address: x.address }));
        else if (type === '1') mapped = arr.map(x => ({ id: x.id, source: 'deposit', created_at: x.created_at, amount: x.usdt_amount, kind: 'in', status: Number(x.status), statusText: this.depositStatus(x.status), tx_hash: x.tx_hash, address: x.to_address || x.address }));
        else mapped = arr.map(x => ({ id: x.id, source: 'account', type: Number(x.type), memo: x.memo, created_at: x.created_at, amount: Math.abs(Number(x.value || 0)), kind: Number(x.value || 0) >= 0 ? 'in' : 'out' }));
        this.list = append ? this.list.concat(mapped) : mapped;
        this.hasMore = this.morePages(r);
      } catch (e) {
        if (append) this.page -= 1;
        else { this.list = []; this.profitSummary = null; }
        this.hasMore = false;
      } finally { this.loadingMore = false; }
    },
    rows(r) { const d = r && r.data && r.data.data; return (d && d.data) || (Array.isArray(d) ? d : []); },
    morePages(r) { const d = r && r.data && r.data.data; return !!(d && d.current_page && d.last_page && Number(d.current_page) < Number(d.last_page)); },
    withdrawStatus(status) {
      const zh = { 1: '待出金', 2: '链上确认中', 3: '成功', 4: '失败' };
      const en = { 1: 'Pending Payout', 2: 'On-chain Confirming', 3: 'Success', 4: 'Failed' };
      return (this.isEn ? en : zh)[Number(status)] || (this.isEn ? 'Expense' : '支出');
    },
    depositStatus(status) {
      const zh = { 1: '等待链上确认', 2: '已到账', 3: '失败' };
      const en = { 1: 'Waiting on-chain confirmation', 2: 'Arrived', 3: 'Failed' };
      return (this.isEn ? en : zh)[Number(status)] || (this.isEn ? 'Income' : '收入');
    },
    displayStatus(item) {
      if (item.statusText) return item.statusText;
      return this.isEn ? (item.kind === 'in' ? 'Income' : 'Expense') : (item.kind === 'in' ? '收入' : '支出');
    },
    displayTypeLabel(item) {
      if (item.source === 'withdraw') return this.isEn ? 'DOGE Swap Withdrawal' : 'DOGE闪兑提现';
      if (item.source === 'deposit') return this.isEn ? 'DOGE Wallet Deposit' : 'DOGE钱包充值';
      if (Number(item.type) === 10) return item.memo || (this.isEn ? 'Administrator Adjustment' : '管理员调节');
      const zh = {
        10: '管理员调节',
        130: '零钱罐买入',
        131: '静态收益',
        132: '动态收益',
        133: '零钱罐转出',
        134: '提现兑换',
        135: '好友互转转出',
        136: '好友互转转入',
        137: '充值到账',
        138: '提现驳回',
        139: '直推奖励',
        140: 'M1级差奖励',
        141: 'M2级差奖励',
        142: 'M3级差奖励',
        143: 'M4级差奖励',
        144: 'M5级差奖励',
        145: 'M6级差奖励',
        146: 'M7级差奖励',
        147: 'M8级差奖励',
        148: 'M9级差奖励',
        149: '平级奖'
      };
      const en = {
        10: 'Administrator Adjustment',
        130: 'Piggy Bank Purchase',
        131: 'Static Reward',
        132: 'Dynamic Reward',
        133: 'Piggy Bank Transfer Out',
        134: 'Withdrawal Exchange',
        135: 'Friend Transfer Out',
        136: 'Friend Transfer In',
        137: 'Deposit Arrived',
        138: 'Withdrawal Rejected',
        139: 'Direct Referral Reward',
        140: 'M1 Level Difference Reward',
        141: 'M2 Level Difference Reward',
        142: 'M3 Level Difference Reward',
        143: 'M4 Level Difference Reward',
        144: 'M5 Level Difference Reward',
        145: 'M6 Level Difference Reward',
        146: 'M7 Level Difference Reward',
        147: 'M8 Level Difference Reward',
        148: 'M9 Level Difference Reward',
        149: 'Same-level Reward'
      };
      return (this.isEn ? en : zh)[Number(item.type)] || (this.isEn ? 'Fund Record' : '资金流水');
    },
    statusClass(item) {
      const status = Number(item.status);
      if (item.source === 'deposit') return status === 2 ? 'doge-status-green' : status === 3 ? 'doge-status-red' : 'doge-status-orange';
      return status === 3 ? 'doge-status-green' : status === 4 ? 'doge-status-red' : 'doge-status-orange';
    },
    formatHash(v) { return v && v.length > 18 ? v.slice(0, 10) + '...' + v.slice(-8) : v; },
    formatTime(v) {
      if (!v) return '--';
      const d = new Date(String(v).replace(' ', 'T'));
      if (Number.isNaN(d.getTime())) return String(v).replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '');
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    summaryMoney(v) { return v === null || v === undefined ? '--' : this.money(v); },
    money(v) { return Number(v || 0).toFixed(2); }
  }
};
</script>
<style scoped>
.profit-summary{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px}.profit-summary div{background:linear-gradient(135deg,#fff8e8,#fff);border-radius:18px;padding:14px 12px;box-shadow:0 6px 18px rgba(75,52,0,.07);border:1px solid #f0dfbd}.profit-summary span{display:block;color:#8b806d;font-size:13px;margin-bottom:8px}.profit-summary b{color:var(--doge-primary);font-size:18px;font-weight:900}.record-tabs{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:14px}.record-tabs button{border:0;border-radius:999px;background:#fff;color:#8b806d;padding:10px 4px;font-weight:700;box-shadow:0 3px 10px rgba(75,52,0,.05)}.record-tabs button.active{background:var(--doge-primary);color:#fff}.detail-card{background:#fff;border-radius:16px;padding:15px;margin-bottom:14px;box-shadow:0 6px 18px rgba(75,52,0,.07)}.detail-card span{color:#8b806d}.detail-card b{font-weight:700;color:#211507}.hash-row{margin-top:10px;color:#8b806d;font-size:12px;word-break:break-all}.doge-status-red{color:#ff6b6b!important}.doge-status-orange{color:var(--doge-primary)!important}
.load-more{display:block;width:100%;height:44px;border:0;border-radius:999px;background:var(--doge-primary);color:#fff;font-weight:700;margin:4px 0 16px}.load-more:disabled{opacity:.6}
</style>
